import { httpClient } from '@/shared/services/HttpClient';

class AccountService {
  url = 'cms/frontuser';

  changePassword(data: any): any {
    return httpClient.post(this.url + '/changepassword', data);
  }

  confirmEmail(data: any): any {
    return httpClient.post(this.url + '/confirmemail', data);
  }

  forgotPassword(data: any): any {
    return httpClient.post(this.url + '/forgotpassword', data);
  }

  register(data: any): any {
    return httpClient.post(this.url + '/register', data);
  }

  resetPassword(data: any): any {
    return httpClient.post(this.url + '/resetpassword', data);
  }

  getProfile(): any {
    return httpClient.get(this.url + '/profile');
  }

  updateProfile(data: any): any {
    return httpClient.put(this.url + '/profile', data);
  }

  resetConfirmEmail(userId?: number): any {
    return httpClient.post(this.url + '/resendconfirmemail', { userId });
  }
}

const accountService = new AccountService();

export { accountService };
